module.exports = __webpack_public_path__ + "assets/ab62e6ef2f765a10eed54470ee9bbe91.svg";